class InstallationInstructionsSearch extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.targetId = this.dataset.targetId;
    this.targetElement = document.getElementById(this.targetId);
    this.defaultTargetHTML = this.targetElement.innerHTML;
    this.timeoutId = null;

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('reset', this.setDefaultTargetHTML.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('keyup', this.debounce(this.onSubmit.bind(this), 250));
    }
  }

  debounce(callback, wait) {
    return (...args) => {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
  }  

  onSubmit(e) {
    e.preventDefault();
    window.clearTimeout(this.timeoutId);

    console.log('submitting', this.input.value);

    if (this.input.value) {
      this.setLoadingState(true);
      this.clearTarget();
      this.getProducts(this.input.value).then(this.renderProducts.bind(this));
    } else {
      this.setLoadingState(false);
      this.setDefaultTargetHTML();
      this.targetElement.classList.remove('no-results');
    }
  }

  getProducts = (query) => fetch(`${routes.predictive_search_url}?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=variants.sku&section_id=installation-instructions-search`).then(resp => resp.text()).then((text) => new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-installation-instructions-search').innerHTML)

  renderProducts(resp) {
    this.setLoadingState(false);
    console.log(resp)
    
    if (resp) {
      this.targetElement.innerHTML = resp;
    } else {
      this.setNoResultsState();
    }
  }

  setDefaultTargetHTML() {
    console.log('set default HTML')
    if (this.targetElement) {
      this.targetElement.innerHTML = this.defaultTargetHTML;
    }
  }

  clearTarget() {
    if (this.targetElement) {
      this.targetElement.innerHTML = '';
      this.targetElement.classList.remove('no-results');
    }
  }

  setLoadingState(loading) {
    this.targetElement.classList.toggle('loading', loading);
  }

  setNoResultsState() {
    console.log('set no results state')
    this.targetElement.innerHTML = this.dataset.noResults;
    this.targetElement.classList.add('no-results');
  }
}

customElements.define('installation-instructions-search', InstallationInstructionsSearch);

function toggleSelectBox(event, button) {
  event.stopPropagation();
  var selectBox = button.nextElementSibling;
  selectBox.classList.toggle('hide');
}

document.body.addEventListener('click', function(event) {
  var selectBoxes = document.querySelectorAll('.dummy-select-box:not(.hide)');
  selectBoxes.forEach(function(selectBox) {
    if (!selectBox.contains(event.target) && !selectBox.previousElementSibling.contains(event.target)) {
      selectBox.classList.add('hide');
    }
  });
}, true);